/**
 * Image, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/ImageComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

export const ImageCore = {
  type: 'Image',
  name: 'Image',
  icon: '🖼️',
  description: 'A static image displayed inline on the screen.',
  category: 'display',
  maxPerScreen: 3,
  getDefaultProperties() {
    // Start empty so the canvas shows a clean "upload an image" placeholder
    // rather than a hardcoded base64 gradient blob. The user fills src by
    // uploading, pasting a URL, or dropping an image file onto the canvas.
    // contain, not cover: most images in a flow are a logo, a screenshot or a diagram, and
    // cropping one of those is always wrong, where letter-boxing a photograph is merely plain.
    // `cover` was the default until 2026-09-21, when it cropped a partner's wordmark down to
    // "azon.con" across half a customer's screen.
    return {
      src: '',
      'alt-text': '',
      'scale-type': 'contain',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      src: {
        type: 'string',
        label: 'Image URL',
        required: true,
      },
      'alt-text': {
        type: 'string',
        label: 'Alt Text',
        required: false,
      },
      'scale-type': {
        type: 'select',
        label: 'Scale Type',
        required: false,
        options: ['cover', 'contain'],
      },
      width: {
        type: 'number',
        label: 'Width',
        required: false,
      },
      height: {
        type: 'number',
        label: 'Height',
        required: false,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.src) {
      errors.push('Image source is required');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    const result = {
      type: 'Image',
      src: properties.src,
    };

    if (properties['alt-text']) {
      result['alt-text'] = properties['alt-text'];
    }

    if (properties['scale-type']) {
      result['scale-type'] = properties['scale-type'];
    }

    if (properties.width) {
      result.width = properties.width;
    }

    if (properties.height) {
      result.height = properties.height;
    }

    return result;
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      src: whatsappComponent.src,
      'alt-text': whatsappComponent['alt-text'] || '',
      'scale-type': whatsappComponent['scale-type'] || 'contain',
      width: whatsappComponent.width,
      height: whatsappComponent.height,
      visible: true,
    };
  },
};
